/** @file runAndReload: a card action that runs one server call, reloads its list, and toasts a failure. */
import type { EditorStore } from '../state/editorTypes';
import { asPose3DError } from '../store/asPose3DError';
import { errorText } from '../store/errorText';

/** A thunk for a menu item: `call()`, then `reload()`; a rejection shows one error toast instead. */
export function runAndReload(store: EditorStore, call: () => Promise<unknown>, reload: () => Promise<void>): () => void {
  return () => {
    call().then(reload, (e: unknown) => { store.getState().notify('error', errorText(asPose3DError(e))); });
  };
}
